import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore'

import auth from './auth';
import coupon from "./coupon";
import doc from './doc';
import form from './form';
import member from './member';
import message from "./message";
import notification from "./notification";
import org from './org';
import statistics from "./statistics";
import ui from './ui';
import user from './user';


export default combineReducers({
    auth,
    coupon,
    doc,
    form,
    member,
    message,
    notification,
    org,
    statistics,
    ui,
    user,
    firebase: firebaseReducer,
    firestore: firestoreReducer,
})